<template>
  <div id="goodsChange">
    <div class="search-box">
      <div>
        <el-button type="primary" size="medium" @click="dialogVisible = true"
          >新增调拨单</el-button
        >
        <el-input
          placeholder="输入订单号"
          style="width: 220px"
          class="pl10"
          v-model="changeForm.synthesisSearch"
        ></el-input>
        <el-button type="primary" size="medium" @click="search">搜索</el-button>
      </div>
      <div class="pt10 alignCenter">
        业务日期：<el-date-picker
          :clearable="false"
          v-model="changeForm.dataTime"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="dataTimeChoose"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <span class="pl10">
          出库仓库：<el-select
            size="small"
            v-model="changeForm.repositoryOutId"
            placeholder="请选择出库仓库"
          >
            <el-option
              v-for="item in repositoryList"
              :key="item.repositoryId"
              :label="item.repositoryName"
              :value="item.repositoryId"
            ></el-option>
          </el-select>
        </span>
        <span class="pl10">
          入库仓库：<el-select
            size="small"
            v-model="changeForm.repositoryInId"
            placeholder="请选择入库仓库"
          >
            <el-option
              v-for="item in repositoryList"
              :key="item.repositoryId"
              :label="item.repositoryName"
              :value="item.repositoryId"
            ></el-option>
          </el-select>
        </span>
        <el-select
          size="small"
          v-model="changeForm.inStorageStatus"
          placeholder="入库状态"
          class="pl10"
        >
          <el-option
            v-for="item in inStorageStatusList"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="pt10">
        <el-select size="small" v-model="changeForm.handlerId" placeholder="经手人">
          <el-option
            v-for="item in handlerList"
            :key="item.shopWorkerUserId"
            :label="item.fullName"
            :value="item.shopWorkerUserId"
          ></el-option>
        </el-select>
        <el-select size="small" v-model="changeForm.isDestroy" placeholder="显示作废">
          <el-option
            v-for="item in isDestroyList"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-button
          size="medium"
          style="margin-left: 10px"
          @click="clearSearch"
          type="primary"
          >清除</el-button
        >
        <el-button size="medium" style="margin-left: 10px" @click="search" type="primary"
          >完成</el-button
        >
      </div>
    </div>
    <div class="searchGrounp">
      <el-table
        :data="tableData"
        style="width: 100%"
        v-loading="loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
        element-loading-text="数据正在加载中"
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column align="center" prop="orderCode" label="单号" />
        <el-table-column
          align="center"
          prop="goodsName"
          label="调拨商品"
          width="180"
          :show-overflow-tooltip="true"
        />
        <el-table-column align="center" prop="repositoryOutName" label="出库仓库" />
        <el-table-column align="center" prop="repositoryInName" label="入库仓库" />
        <el-table-column align="center" prop="businessTime" label="业务日期" />
        <el-table-column align="center" prop="inStorageStatus" label="状态">
          <template slot-scope="scope">
            <div
              v-if="scope.row.inStorageStatus == 0"
              style="
                width: 60px;
                height: 30px;
                line-height: 30px;
                border-radius: 10px;
                border: 1px solid #afafaf;
                margin: auto;
                color: #afafaf;
                font-size: 10px;
              "
            >
              未入库
            </div>
            <div
              v-if="scope.row.inStorageStatus == 1"
              style="
                width: 60px;
                height: 30px;
                line-height: 30px;
                border-radius: 10px;
                border: 1px solid #fdb99e;
                margin: auto;
                color: #fdb99e;
                font-size: 10px;
              "
            >
              入库
            </div>
            <div
              v-if="scope.row.inStorageStatus == 2"
              style="
                width: 60px;
                height: 30px;
                line-height: 30px;
                border-radius: 10px;
                border: 1px solid #6abcf8;
                margin: auto;
                color: #6abcf8;
                font-size: 10px;
              "
            >
              部分入库
            </div>
            <div
              v-if="scope.row.inStorageStatus == 3"
              style="
                width: 60px;
                height: 30px;
                line-height: 30px;
                border-radius: 10px;
                border: 1px solid #ccc;
                margin: auto;
                color: #ccc;
                font-size: 10px;
              "
            >
              作废
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button class="button5" @click="detail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div
        v-if="tableData.length > 0"
        class="block"
        style="float: right; margin-top: 10px"
      >
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pageNo"
          :page-size="queryInfo.row"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      class="goods-dialog"
      title="增加调拨单"
      :visible.sync="dialogVisible"
      width="25%"
      :before-close="handleClose"
    >
      <span>
        <div class="line"></div>
        <div class="pt20">
          出库仓库：
          <el-select
            size="small"
            v-model="repositoryOutId"
            placeholder="请选择出库仓库"
            @change="repositoryOutIdChange"
          >
            <el-option
              v-for="item in repositoryList1"
              :key="item.repositoryId"
              :label="item.repositoryName"
              :value="item.repositoryId"
            ></el-option>
          </el-select>
        </div>
        <div class="pt20">
          入库仓库：
          <el-select
            size="small"
            v-model="repositoryInId"
            placeholder="请选择入库仓库"
            @change="repositoryInIdChange"
          >
            <el-option
              v-for="item in repositoryList1"
              :key="item.repositoryId"
              :label="item.repositoryName"
              :value="item.repositoryId"
            ></el-option>
          </el-select>
        </div>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="goChooseGoods">选择商品</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  repositoryList,
  Shop_handlerList,
  goodsChangeList,
  goodsChangeListTotalNum,
} from "../api";
export default {
  data() {
    return {
      changeForm: {
        synthesisSearch: "",
        dataTime: "",
        startDate: "",
        endDate: "",
        repositoryInId: "",
        repositoryOutId: "",
        inStorageStatus: "",
        handlerId: "",
        isDestroy: "",
      },
      repositoryOutId: "",
      repositoryInId: "",
      repositoryList: [],
      inStorageStatusList: [
        { value: "", name: "全部入库状态" },
        { value: 0, name: "未入库" },
        { value: 1, name: "入库" },
        { value: 2, name: "部分入库" },
      ],
      handlerList: [],
      isDestroyList: [
        { value: "", name: "显示作废" },
        { value: 0, name: "显示" },
        { value: 1, name: "不显示" },
      ],
      queryInfo: {
        pageNo: 1,
        row: 10,
      },
      total: 0,
      status: "",
      tableData: [],
      dialogVisible: false,
      repositoryList1: [],
      loading: false,
    };
  },
  created() {
    this.getRepositoryList();
    this.getGoodsChangeList();
  },
  methods: {
    dataTimeChoose() {
      this.changeForm.startDate = this.changeForm.dataTime[0];
      this.changeForm.endDate = this.changeForm.dataTime[1];
    },
    // 清楚搜索
    clearSearch() {
      this.changeForm = {};
      this.getGoodsChangeList();
    },
    // 搜索
    search() {
      this.status = 1;
      this.queryInfo.pageNo = 1;
      this.getGoodsChangeList(
        this.changeForm.synthesisSearch,
        this.changeForm.startDate,
        this.changeForm.endDate,
        this.changeForm.repositoryInId,
        this.changeForm.repositoryOutId,
        this.changeForm.inStorageStatus,
        this.changeForm.isDestroy,
        this.changeForm.handlerId
      );
    },
    repositoryOutIdChange(val) {
      var index = this.repositoryList1.findIndex((item) => {
        return item.repositoryId == val;
      });
      if (index !== -1) {
        localStorage.setItem("repositoryOutId", this.repositoryList1[index].repositoryId);
        localStorage.setItem(
          "repositoryOutName",
          this.repositoryList1[index].repositoryName
        );
        localStorage.setItem("checkShopStoreId", this.repositoryList1[index].shopStoreId);
        localStorage.setItem(
          "checkRepositoryId",
          this.repositoryList1[index].repositoryId
        );
      }
    },
    repositoryInIdChange(val) {
      console.log(this.repositoryList1, "this.repositoryList1");
      var index = this.repositoryList1.findIndex((item) => {
        return item.repositoryId == val;
      });
      if (index !== -1) {
        localStorage.setItem("repositoryInId", this.repositoryList1[index].repositoryId);
        localStorage.setItem(
          "repositoryInName",
          this.repositoryList1[index].repositoryName
        );
      }
    },
    // 仓库
    getRepositoryList() {
      repositoryList({
        isManager: 1,
        isNeedAll: 1,
        pageNo: 1,
        row: 9999,
      }).then((res) => {
        if (res.code == 1) {
          this.repositoryList = JSON.parse(JSON.stringify(res.data));
          this.repositoryList.unshift({
            repositoryName: "全部仓库",
            repositoryId: "",
          });
          this.repositoryList1 = JSON.parse(JSON.stringify(res.data));
          this.repositoryInId = this.repositoryList1[0].repositoryId;
          this.repositoryOutId = this.repositoryList1[1].repositoryId;
          localStorage.setItem("repositoryInId", this.repositoryInId);
          localStorage.setItem(
            "repositoryInName",
            this.repositoryList1[0].repositoryName
          );
          localStorage.setItem("repositoryOutId", this.repositoryOutId);
          localStorage.setItem(
            "repositoryOutName",
            this.repositoryList1[1].repositoryName
          );
          localStorage.setItem("checkShopStoreId", this.repositoryList1[1].shopStoreId);
          localStorage.setItem("checkRepositoryId", this.repositoryOutId);
          this.Shop_handlerList();
        }
      });
    },
    // 经手人列表
    Shop_handlerList() {
      Shop_handlerList({
        isManager: 1,
        pageNo: 1,
        row: 99999,
      }).then((res) => {
        if (res.code == 1) {
          this.handlerList = res.data[0].workers;
          this.handlerList.unshift({
            fullName: "全部经手人",
            shopWorkerUserId: "",
          });
        }
      });
    },
    getGoodsChangeList(
      synthesisSearch,
      startDate,
      endDate,
      repositoryInId,
      repositoryOutId,
      inStorageStatus,
      isDestroy,
      handlerId
    ) {
      this.loading = true;
      goodsChangeList({
        isManager: 1,
        pageNo: this.queryInfo.pageNo,
        row: this.queryInfo.row,
        orderCode: synthesisSearch,
        startDate: startDate,
        endDate: endDate,
        repositoryInId: repositoryInId,
        repositoryOutId: repositoryOutId,
        inStorageStatus: inStorageStatus,
        isDestroy: isDestroy,
        handlerId: handlerId,
      }).then((res) => {
        this.loading = false;
        if (res.code == 1) {
          this.tableData = res.data;
          for (let i = 0; i < this.tableData.length; i++) {
            if (this.tableData[i].productJson.length >= 1) {
              this.str = this.tableData[i].productJson
                .map((item) => item.goodsName)
                .join(",");
              this.tableData[i].goodsName = this.str;
            }
            if (this.tableData[i].isDestroy == 1) {
              this.tableData[i].inStorageStatus = 3;
            }
          }
          goodsChangeListTotalNum({
            isManager: 1,
            pageNo: this.queryInfo.pageNo,
            row: this.queryInfo.row,
            orderCode: synthesisSearch,
            startDate: startDate,
            endDate: endDate,
            repositoryInId: repositoryInId,
            repositoryOutId: repositoryOutId,
            inStorageStatus: inStorageStatus,
            isDestroy: isDestroy,
            handlerId: handlerId,
          }).then((res) => {
            if (res.code == 1) {
              this.total = res.data.totalNum;
            } else if (res.code == 2) {
              this.$message.error(res.msg);
              this.$router.push("/");
            } else {
              this.$message.error(res.msg);
            }
          });
        } else if (res.code == -1) {
          this.tableData = [];
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleCurrentChange(val) {
      this.queryInfo.pageNo = val;
      if (this.status == 1) {
        this.getGoodsChangeList(
          this.changeForm.synthesisSearch,
          this.changeForm.startDate,
          this.changeForm.endDate,
          this.changeForm.repositoryInId,
          this.changeForm.repositoryOutId,
          this.changeForm.inStorageStatus,
          this.changeForm.isDestroy,
          this.changeForm.handlerId
        );
      } else {
        this.getGoodsChangeList();
      }
    },
    handleClose() {
      this.dialogVisible = false;
    },
    // 选择商品
    goChooseGoods() {
      if (this.repositoryInId == this.repositoryOutId) {
        this.$message.error("入库仓库和出库仓库不能一样");
        return;
      } else if (this.repositoryInId == "") {
        this.$message.error("请选择入库仓库");
        return;
      } else if (this.repositoryOutId == "") {
        this.$message.error("请选择出库仓库");
        return;
      }
      this.$router.push({
        path: "/invoicing/chooseGoods",
        query: { goodsStyle: 4 },
      });
      localStorage.setItem("goodsStyle", 4);
    },
    // 详情
    detail(item) {
      // console.log(item)
      this.$router.push("/invoicing/goodsChangeDetail");
      localStorage.setItem("changeOrderId", item.orderId);
      localStorage.setItem("changeIsDestroy", item.isDestroy);
    },
  },
};
</script>

<style scoped>
.search-box {
  width: calc(100vw - 250px);
  height: 174px;
  background-color: #f8f8f8;
  position: absolute;
  top: 51px;
  padding: 20px;
  box-sizing: border-box;
}
.pl10 {
  padding-left: 10px;
  box-sizing: border-box;
}
.pt10 {
  padding-top: 10px;
  box-sizing: border-box;
}
.pt20 {
  padding-top: 20px;
  box-sizing: border-box;
}
.searchGrounp {
  position: absolute;
  top: 250px;
  width: calc(100vw - 250px);
  padding: 20px;
  box-sizing: border-box;
}
.line {
  width: 444px;
  height: 1px;
  background: rgba(16, 142, 233, 1);
}
::v-deep .el-table th {
  background-color: #f8f8f8;
}
</style>
<style lang="less">
/* .el-table th {
    background-color: #f2f2f2;
} */
.goods-dialog {
  .el-dialog__title {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(4, 130, 220, 1);
  }
  .el-dialog__body {
    padding: 5px 16px 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
  }
}
</style>
